// extracted by mini-css-extract-plugin
export default {"wrapper":"single-image-input_wrapper__e3O3f","image":"single-image-input_image__HMSqz","input":"single-image-input_input__eovhq","icon":"single-image-input_icon__x67Uy"};